const ValidationWrap = () => {
	const blocks = document.querySelectorAll(".validation-wrap");
	if (!blocks.length) {
		return;
	}

	blocks.forEach((item) => {
		const form = item.querySelector("form");
		if (!form) return;

		form.addEventListener("submit", function (e) {
			e.preventDefault();
			let validation = true;

			// Validate required fields
			const requiredFields = form.querySelectorAll('[required]');
			requiredFields.forEach((field) => {
				if (field.value === '') {
					validation = false;
					field.closest('.form-group').classList.add('has-error');
				}
				
				if (field.type === 'checkbox') {
					if (!field.checked) {
						validation = false;
						field.closest('.form-group').classList.add('has-error');
					}
				}
				
				if (field.type === 'number') {
					const minValue = parseInt(field.getAttribute('min'), 10);
					if (field.value < minValue) {
						validation = false;
						field.closest('.form-group').classList.add('has-error');
					}
				}
			});

			// Validate email fields
			const emailFields = form.querySelectorAll('input[type="email"]');
			emailFields.forEach((field) => {
				if (field.value !== '') {
					const emailReg = /^.+@.+\..+$/;
					if (!emailReg.test(field.value)) {
						validation = false;
						field.closest('.form-group').classList.add('has-error');
					}
				}
			});

			if (validation) {
				const formWrap = form.closest('.validation-wrap');
				formWrap.classList.add('submitting');
				setTimeout(() => {
					formWrap.classList.remove('submitting');
					formWrap.classList.add('submitted');
				}, 1000);
				
				// Trigger custom event
				const submitEvent = new CustomEvent('validation-submit', { detail: form });
				form.dispatchEvent(submitEvent);
			} else {
				// Trigger custom event
				const errorEvent = new CustomEvent('validation-error', { detail: form });
				form.dispatchEvent(errorEvent);
			}
		});

		// Remove error class on focus/click
		document.addEventListener('click', function (e) {
			if (e.target.matches('.has-error input, .has-error textarea')) {
				e.target.closest('.has-error').classList.remove('has-error');
			}
		});

		document.addEventListener('focus', function (e) {
			if (e.target.matches('.has-error input, .has-error textarea')) {
				e.target.closest('.has-error').classList.remove('has-error');
			}
		}, true);

		// Reset form if already submitted
		if (item.classList.contains('submitted')) {
			form.reset();
		}

		// Clean up error states
		const errorElements = item.querySelectorAll('.has-error');
		errorElements.forEach((el) => el.classList.remove('has-error'));
		item.classList.remove('submitted');
	});
};

export default ValidationWrap;